import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Lottie from 'react-lottie';
import { useMediaQuery } from "@mui/material";
import animationData from '../LandingPage/animateds.json';
import Step1Image from '/Images/stepOTC.svg';
import Step2Image from '/Images/stepOTC2.svg';
import Step3Image from '/Images/stepOTC3.svg';
import Step4Image from '/Images/stepOTC4.svg';

const Platform = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [activeStep, setActiveStep] = useState(1);
  const [fade, setFade] = useState(false);
  const isMobile = useMediaQuery("(max-width: 767px)");

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setFade(true);
  //     setTimeout(() => {
  //       setActiveStep(prevStep => (prevStep % 4) + 1);
  //       setFade(false);
  //     }, 500);
  //   }, 8000);

  //   return () => clearInterval(interval);
  // }, []);

  const handleStepClick = (step) => {
    setFade(true);
    setTimeout(() => {
      setActiveStep(step);
      setFade(false);
    }, 500);
  };

  const steps = [
    { number: 1, title: 'Business Verification', description: 'Complete your business verification process', image: Step1Image },
    { number: 2, title: 'Request for Quote', description: 'Get a price quote for orders', image: Step2Image },
    { number: 3, title: 'Transfer Funds', description: 'Send the required funds to the provided payment method', image: Step3Image },
    { number: 4, title: 'Receive Settlement', description: 'Receive your purchased asset on time', image: Step4Image },
  ];

  const styles = {
    container: {
      maxWidth: '1290px',
      margin: '0 auto',
      padding: isMobile ? '20px' : '40px 20px',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: 'center',
    },
    titleSection: {
      textAlign: 'center',
     },
    title: {
      fontSize: isMobile ? '30px' : '40px',
      fontWeight: 'bold',
      background: 'linear-gradient(90deg, #2D669B 0%, #0582CA 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      width: isMobile? "auto ":"611px",
      marginLeft:"auto",
      marginRight:"auto",

     },
    stepsContainer: {
      display: 'flex',
      flexDirection: isMobile ? 'row' : 'column',
      alignItems: isMobile ? 'center' : 'flex-start',
      justifyContent: isMobile ? 'space-around' : 'flex-start',
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      flex: '1',
      paddingRight: isMobile ? '0' : '40px',
      marginBottom: isMobile ? '20px' : '0',
    },
    stepItem: (number) => ({
      display: 'flex',
      alignItems: 'center',
      marginBottom: isMobile ? '0' : '10px',
      marginRight: isMobile ? '10px' : '0',
      position: 'relative',
    }),
    stepButtonContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    stepButton: (isActive) => ({
      background: isActive ? '#2D669B' : '#DCD7D4',
      color: isActive ? '#F4E37B' : '#2D669B',
      border: 'transparent',
      borderRadius: '50%',
      width: isMobile ? '50px' : '75px',
      height: isMobile ? '50px' : '75px',
      fontSize: isMobile ? '1.2rem' : '2rem',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      boxSizing: 'border-box',
      boxShadow: isActive 
      ? '0px 4px 10px rgba(0, 0, 0, 0.2)' // Darker shadow when active
      : '0px 2px 6px rgba(0, 0, 0, 0.1)', // Lighter shadow when inactive
    }),
    
    dashedLine: {
      marginTop: '10px',
      borderLeft: '1px dashed #2D669B',
      height: '30px',
    },
    stepDescription: (number) => ({
      color: '#6D6D6D',
      fontSize: isMobile ? '0.75rem' : '1rem',
      textAlign: 'left',
      marginLeft: isMobile ? '10px' : '20px',
      marginBottom: number === 4 ? '0px' : '20px',
      maxWidth: isMobile ? '140px' : '457px',
    }),
    contentContainer: {
      flex: '2',
      textAlign: 'center',
      padding: isMobile ? '10px' : '20px',
      borderRadius: '10px',
      maxWidth: '600px',
      minHeight: isMobile ? '300px' : '567px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      order: isMobile ? '-1' : 'unset',
      marginBottom: isMobile ? '20px' : '0',
    },
    fade: {
      opacity: fade ? 0 : 1,
      transition: 'opacity 0.5s ease-in-out',
    },
  };

  return (
    <section
      style={{
        background: '#E0DCD9',
        paddingTop: '1rem',
        padding: '4rem 0',
        paddingBottom: '4rem',
        fontFamily: 'Poppins',
      }}
    >
      <div style={styles.titleSection}>
      <h2 style={{ ...styles.title, marginBottom: "0px" }}>A Step-by-step Guide to Our  OTC Trading Process</h2>
      </div>

      <div style={styles.container}>
        <div style={styles.stepsContainer}>
          {steps.map((step, index) => {
            const isActive = activeStep === step.number;
            const lineHeight = step.description.length > 50 ? '60px' : '30px';

            return (
              <React.Fragment key={index}>
                <div style={styles.stepItem(step.number)} onClick={() => handleStepClick(step.number)}>
                  <div style={styles.stepButtonContainer}>
                    <button style={styles.stepButton(isActive)}>
                      {step.number}
                    </button>
                    {!isMobile && index < steps.length - 1 && (
                      <div style={{ ...styles.dashedLine, height: lineHeight }}></div>
                    )}
                  </div>
                  <div style={styles.stepDescription(step.number)}>
                    <h4 style={{ color: isActive ? '#214D73' : '#6D6D6D', fontWeight: 'bold', fontSize: '18px', marginBottom: '0px' }}>{step.title}</h4>
                    <p>{step.description}</p>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
        <div style={{ ...styles.contentContainer, ...styles.fade }} data-aos="fade-up">
          {steps[activeStep - 1].image ? (
            <img src={steps[activeStep - 1].image} alt={`Step ${activeStep}`} style={{ width: '100%', height: 'auto', maxWidth: isMobile ? '80%' : '100%' }} />
          ) : (
            <Lottie options={{ loop: true, autoplay: true, animationData }} height={isMobile ? 300 : 567} width={isMobile ? 300 : 567} />
          )}
        </div>
      </div>
    </section>
  );
};

export default Platform;
